import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Modal} from '@softline/ui-core';
import {ContentView, InputContentViewComponent} from '../../components/input-content-view/input-content-view.component';
import {of, take} from 'rxjs';
import {map} from 'rxjs/operators';
import {Entity, isDefined} from '@softline/core';
import {ScrollIntoViewDirective} from '../../directives/scroll-into-view.directive';
import {HardwareListeEntityInputParams} from '../../strategies/hardware-liste-entity-input.strategy';

@Component({
    selector: 'soft-hardware-liste-entity-input-dialog',
    imports: [CommonModule, InputContentViewComponent, ScrollIntoViewDirective],
    templateUrl: './hardware-liste-entity-input-dialog.component.html',
    styleUrls: ['./hardware-liste-entity-input-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HardwareListeEntityInputDialogComponent implements OnInit, Modal<any> {

  close!: (result: any) => void;
  params!: HardwareListeEntityInputParams;

  readonly views: ContentView[] = [];

  trackByFn(_: number, entity: Entity): number | string {
    return entity.id;
  }

  registerCloseHandler(handler: (result: any) => void) {
    this.close = handler;
  }

  ngOnInit(): void {
    console.log(this.params);

    this.views.push(
      {
        id: 'results',
        label: 'Ergebnis',
        visible$: of(true)
      },
      {
        id: 'edit',
        label: 'Bearbeiten',
        visible$: this.params.entityInEditing$.pipe(
          map(o => !!o)
        )
      },
      {
        id: 'create',
        label: 'Erstellen',
        visible$: this.params.entityEditTemplate$.pipe(map(o => isDefined(o)))
      }
    );
  }
}
